<template>
  <div class="sticker-sample-banner" :class="{ 'sticker-sample-banner--guest': isGuest }">
    <div class="sticker-sample-banner__text">
      <div class="sticker-sample-banner__headline">
        <strong>
          10 Custom Stickers for
          <span class="sticker-sample-banner__discounted-price">$8.00</span>
        </strong>
      </div>
      <div>
        <strong>Pre-set 9 square inches (3" by 3")</strong>
      </div>
    </div>
    <div class="sticker-sample-banner__shipping">
      <UseSvg
        icon="free-shipping-truck"
        class="sticker-sample-banner__shipping-icon"
        width="60"
        height="60"
      />
      <div class="sticker-sample-banner__shipping-text">
        <strong>FREE SHIPPING<br />ON YOUR 1ST ORDER!</strong>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "common/vue/components/UseSvg.vue";
import { useDtfStore } from "./store";

export default {
  name: "StickerSampleBanner",
  components: { UseSvg },
  computed: {
    ...mapState(useDtfStore, ["isGuest"])
  }
};
</script>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

$ice-gray: #eef2f6;

.sticker-sample-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 8px;
  background-color: $ice-gray;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  text-align: center;

  @include with-desktop {
    padding: 0 30px 15px;
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }

  &--guest {
    margin-bottom: 16px;
  }

  &__text {
    flex: 1;
    font-size: 14px;
    line-height: 17px;

    @include with-desktop {
      font-size: 16px;
      line-height: 19px;
    }
  }

  &__headline {
    margin: 20px 0 8px;
    font-size: 17px;
    line-height: 22px;

    @include with-desktop {
      font-size: 19px;
      line-height: 24px;
    }
  }

  &__discounted-price {
    color: $variant-red;
    font-size: 19px;

    @include with-desktop {
      font-size: 21px;
    }
  }

  &__shipping {
    display: flex;
    align-items: center;
    line-height: 16px;

    @include with-desktop {
      flex-direction: column;
      text-align: center;
    }
  }

  &__shipping-icon {
    margin-right: 10px;
  }

  &__shipping-text {
    color: $green-date;
    font-size: 13px;

    @include with-desktop {
      font-size: 14px;
    }
  }
}
</style>
